import React, { useState, useEffect } from "react";
import economicActivities from "../../utils/economicActivities";

export function EconomicActivitySelect({ value, onChange, label, placeholder, className }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [filteredActivities, setFilteredActivities] = useState(economicActivities);

    // Encontrar la actividad seleccionada
    const selectedActivity = economicActivities.find(activity => activity.code === value);

    useEffect(() => {
        if (!searchTerm) {
            setFilteredActivities(economicActivities);
        } else {
            const filtered = economicActivities.filter(activity =>
                (activity.code && activity.code.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (activity.codev4 && activity.codev4.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (activity.name && activity.name.toString().toLowerCase().includes(searchTerm.toLowerCase()))
            );
            setFilteredActivities(filtered);
        }
    }, [searchTerm]);

    const handleSelect = (activity) => {
        onChange(activity.code);
        setIsOpen(false);
        setSearchTerm("");
    };

    return (
        <div className={`relative ${className}`}>
            {label && (
                <label className="text-base block mb-2">
                    {label}
                </label>
            )}

            <div className="relative">
                <input
                    type="text"
                    className="w-full rounded-3xl h-12 p-6 border border-purple cursor-pointer"
                    value={selectedActivity ? `${selectedActivity.codev4} - ${selectedActivity.name}` : ""}
                    onChange={() => { }} // Controlled component
                    onClick={() => setIsOpen(!isOpen)}
                    readOnly
                    placeholder={placeholder || "Seleccionar actividad económica"}
                />

                <div
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                        ▼
                    </span>
                </div>
            </div>

            {isOpen && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-purple rounded-lg shadow-lg max-h-64 overflow-hidden">
                    <div className="p-2">
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded"
                            placeholder="Buscar por código V3, código V4 o descripción..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                    </div>

                    <div className="overflow-y-auto max-h-48">
                        {filteredActivities.map((activity) => (
                            <div
                                key={activity.code}
                                className="p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                                onClick={() => handleSelect(activity)}
                            >
                                <div className="font-bold text-lg text-cyan mb-1">
                                    {activity.codev4}
                                </div>
                                <div className="text-sm text-gray-600 mb-1">
                                    {activity.name}
                                </div>
                                <div className="text-xs text-gray-400 italic">
                                    Código versión anterior: {activity.code}
                                </div>
                            </div>
                        ))}

                        {filteredActivities.length === 0 && (
                            <div className="p-3 text-gray-500 text-center">
                                No se encontraron actividades económicas
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Overlay para cerrar el dropdown */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-40"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
}

export default EconomicActivitySelect;